<template>
  <v-row no-gutters>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{snackbarMsg}}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <!-- company contact list dialog -->
    <dialog-company-contact-list
      v-if="contactListDialog"
      :dialog="contactListDialog"
      :company="company"
      :assignable="true"
      v-on:dialog-company-contact-list-close="onDialogCompanyContactListClose"
    ></dialog-company-contact-list>

    <!-- Dialog for confirming contact save -->
    <v-dialog v-model="saveContactAsDialog" width="300px">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col>
              <span>Save contact as:</span>
              <input class="form-control" v-model="saveContactTag" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters justify="center">
            <v-btn outlined dark color="primary" @click="confirmSaveContact">SAVE</v-btn>
            <v-btn color="error" outlined dark @click="saveContactAsDialog = false">CANCEL</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col>
        <v-row no-gutters>
          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  outlined
                  color="primary"
                  class="font-italic"
                  @click="useOwnContact"
                >
                  <v-icon left>mdi-contacts</v-icon>Assign own contact
                </v-btn>
              </template>
              Use / assign your company contact
            </v-tooltip>
          </v-col>

          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  outlined
                  color="primary"
                  class="font-italic"
                  @click="onContactList"
                >
                  <v-icon left>mdi-view-list</v-icon>Load saved contacts
                </v-btn>
              </template>
              Select from your saved contact list
            </v-tooltip>
          </v-col>

          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  outlined
                  color="teal darken-4"
                  class="font-italic"
                  @click="onSaveContact"
                >
                  <v-icon left>mdi-content-save</v-icon>Save contact
                </v-btn>
              </template>
              Save this contact information into your contact list
            </v-tooltip>
          </v-col>

          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" outlined color="error" class="font-italic" @click="resetContact">
                  <v-icon left>mdi-delete</v-icon>Reset contact
                </v-btn>
              </template>
              Clear / reset this contact information
            </v-tooltip>
          </v-col>
        </v-row>

        <v-row class="mt-4" no-gutters>
          <v-col>
            <contact-info-layout v-model="contact"></contact-info-layout>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-row>
</template>
<script>
import constant from "../../const";
import DialogCompanyContactList from "@/components/user/DialogCompanyContactList.vue";
import ContactInfoLayout from "@/components/shared/ContactInfoLayout.vue";
export default {
  props: ["value", "companyInfo"],
  components: {
    DialogCompanyContactList,
    ContactInfoLayout
  },

  data() {
    return {
      contact: this.value,
      company: this.companyInfo,

      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,

      saveContactAsDialog: false,
      saveContactTag: null,

      contactListDialog: false,

      default_contact: {
        company_contact_id: null,
        company_contact_name: null,
        company_id: null,
        tag: null,
        contact_info: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          notify: false
        },
        address: {
          line_1: null,
          line_2: null,
          line_3: null,
          city: null,
          postcode: null,
          state: null,
          code_country: null,
          country: null
        }
      },

      countries: []
    };
  },

  created() {
    this.loadCountriesList();
  },

  watch: {
    value() {
      this.contact = this.value;
    },
    contact() {
      this.handleInput();
    }
  },

  methods: {
    handleInput() {
      this.$emit("input", this.contact);
    },

    /**
     * Get country list
     */
    loadCountriesList() {
      var response = null;

      this.$https
        .get("/api/countries")
        .then(resp => (response = resp.data))
        .catch(err => {
          response = err.response;
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.countries = response.data;
          }
        });
    },

    /**
     * Use Own contact information
     */
    useOwnContact() {
      this.contact = {
        address: this.company.address,
        contact_info: this.company.contact_info,
        company_contact_id: null,
        company_contact_name: this.company.name,
        company_id: this.company.company_id,
        tag: null
      };
    },

    /**
     * Load and display contact list
     */
    onContactList() {
      this.contactListDialog = true;
    },

    /**
     *  on closing the contact list dialog
     */
    onDialogCompanyContactListClose(contactInfo) {
      this.contactListDialog = false;
      if (contactInfo != null) {
        this.contact = contactInfo;
      }
    },

    /**
     * On Save contact information open dialog
     */
    onSaveContact() {
      this.saveContactAsDialog = true;
    },

    /**
     * Confirm save contact information
     */
    confirmSaveContact() {
      if (this.contact.company_contact_name == null) {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg =
          "Please enter the company contact name / company name";
        return;
      }
      this.$root.blockUIshow = true;
      this.$root.blockUImsg = "Saving contact...";

      // add the saved tag value
      this.contact.tag = this.saveContactTag;

      // create a new contact
      if (this.contact.company_contact_id == null) {
        this.$https
          .post(
            `/api/company/${this.company.company_id}/contacts`,
            this.contact
          )
          .then(resp => {
            if (resp.data.status == constant.RESPONSE_STATUS_OK) {
              this.saveContactAsDialog = false;
              this.saveContactTag = null;

              this.showSnackbar = true;
              this.snackbarColor = "success";
              this.snackbarMsg = resp.data.msg;
            } else {
              this.showSnackbar = true;
              this.snackbarColor = "error";
              this.snackbarMsg = resp.data.msg;
            }
          })
          .catch(err => {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = err;
          })
          .finally(() => {
            this.$root.blockUIshow = false;
          });
      } else {
        // update an existing contact
        this.$https
          .put(
            `/api/company/contacts/${this.contact.company_contact_id}`,
            this.contact
          )
          .then(resp => {
            if (resp.data.status == constant.RESPONSE_STATUS_OK) {
              this.saveContactAsDialog = false;
              this.saveContactTag = null;

              this.showSnackbar = true;
              this.snackbarColor = "success";
              this.snackbarMsg = resp.data.msg;
            } else {
              this.showSnackbar = true;
              this.snackbarColor = "error";
              this.snackbarMsg = resp.data.msg;
            }
          })
          .catch(err => {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = err;
          })
          .finally(() => {
            this.$root.blockUIshow = false;
          });
      }
    },

    /**
     * Clear / reset contact information
     */
    resetContact() {
      // this.contact = Object.assign(this.contact, this.default_contact);
      this.contact = this.default_contact;
    }
  },
  computed: {
    sortedCountriesList: function() {
      return this.countries.sort(function(a, b) {
        return ("" + a.name).localeCompare(b.name);
      });
    }
  }
};
</script>

<style>
</style>
